import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=16d2d4fa&scoped=true"
import script from "./CheckboxView.vue?vue&type=script&lang=js"
export * from "./CheckboxView.vue?vue&type=script&lang=js"
import style0 from "./CheckboxView.vue?vue&type=style&index=0&id=16d2d4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2d4fa",
  null
  
)

export default component.exports